// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const EmailIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="15.859"
    viewBox="0 0 24 15.859"
    fill="currentColor"
  >
    <path
      d="M-1120.975-17899.666a2.6,2.6,0,0,1-.652-.131l5.984-5.93,1.174,1.16a4,4,0,0,0,2.828,1.16,4,4,0,0,0,2.828-1.16l1.174-1.16,5.984,5.93a2.6,2.6,0,0,1-.652.131Zm15.22-7.932,5.981-5.928a2.494,2.494,0,0,1,.132.643v10.574a2.545,2.545,0,0,1-.131.641Zm-17.887,5.289v-10.574a2.554,2.554,0,0,1,.131-.643l5.982,5.928-5.982,5.928A2.524,2.524,0,0,1-1123.642-17902.309Zm11.057-4.125-9.04-8.961a2.571,2.571,0,0,1,.649-.131h18.667a2.587,2.587,0,0,1,.649.131l-9.04,8.961a1.338,1.338,0,0,1-.943.387A1.334,1.334,0,0,1-1112.585-17906.434Z"
      transform="translate(1123.642 17915.525)"
    />
  </Icon>
);

export default EmailIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Social/Email.js